module.exports = __webpack_public_path__ + "img/logo.63d2898e.png";